module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAMAAACf4xmcAAAAXVBMVEUAAABnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqwpySvmAAAAHnRSTlMA0973dYu8HvvB4ybKLBvOORDZspOCbFUgF/GfRgEalkqlAAAArElEQVQ4y+3MyQ6DMAxFUZNCZihz6ZT//8wGcJUSYnXT7rgb60lHhqN0XYaxB0DTa1w8Yq17d/HLWBw6YtmGgeByGWzPbDHXl8tuOMWGz21IVkCotI5mQZ094eoLM7NSQnCShV8CYFI3mplsVT5xpxiqah0NyYT16goYyZ5TplARDKsqvHVdkyyUS6d/yE6O/ZsNMRuTTI35tk6mmDxFSbdjrUumI8ZZMgVHyV4DRRVedIwTjQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_ico3.png
// module id = hzQo
// module chunks = 1